import React__default from 'react';
import { Icon } from '@grandvisionhq/icons';
import { AdyenBrands } from '../models/cart-payment-methods/cart-payment-methods.js';

const getBrandIcon = (brand)=>{
    switch(brand){
        case AdyenBrands.MASTERCARD:
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "mastercard",
                name: "mastercard",
                viewBox: "6 0 36 28",
                width: 36,
                height: 30
            });
        case AdyenBrands.AMEX:
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "amex",
                name: "amex",
                viewBox: "0 0 40 24",
                width: 40,
                height: 24
            });
        case AdyenBrands.MAESTRO:
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "maestro",
                name: "maestro",
                viewBox: "6 0 36 28",
                width: 36,
                height: 30
            });
        case AdyenBrands.DANKORT:
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "dankort",
                name: "dankort",
                viewBox: "0 0 39 19",
                width: 39,
                height: 19
            });
        case AdyenBrands.VISA:
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "visa",
                name: "visa",
                viewBox: "0 7 47 20",
                width: 47,
                height: 30
            });
        case AdyenBrands.BANCONTACTMC:
            return /*#__PURE__*/ React__default.createElement(Icon, {
                key: "bancontact",
                name: "bancontact",
                width: 54,
                height: 33,
                viewBox: "1 0 54 33"
            });
        default:
            return undefined;
    }
};
const getCreditCardBrandsIcons = (brands)=>brands.reduce((acc, brand)=>[
            ...acc,
            getBrandIcon(brand)
        ]
    , [])
;

export { getBrandIcon, getCreditCardBrandsIcons };
//# sourceMappingURL=get-creditcard-brands-icons.js.map
